var map = {
	"./add_circle-24px.svg": 143,
	"./areamap.svg": 144,
	"./areamap10.svg": 145,
	"./areamap11.svg": 146,
	"./areamap2.svg": 147,
	"./areamap3.svg": 148,
	"./areamap4.svg": 149,
	"./areamap5.svg": 150,
	"./areamap6.svg": 151,
	"./areamap7.svg": 152,
	"./areamap8.svg": 153,
	"./areamap9.svg": 154,
	"./bell-solid.svg": 72,
	"./caret-down-solid.svg": 155,
	"./create-24px.svg": 104,
	"./credit-card-payment.svg": 73,
	"./credit-card-regular.svg": 105,
	"./credit-card-solid.svg": 106,
	"./delete-24px.svg": 98,
	"./dizbuzzicon.svg": 156,
	"./folder_open-24px.svg": 99,
	"./home-solid.svg": 74,
	"./loan.svg": 75,
	"./loanx-Pattern.svg": 76,
	"./loanx-nav-footer-Pattern.svg": 157,
	"./loanxxxx-logo.svg": 158,
	"./login icon.svg": 77,
	"./login-password-icon.svg": 78,
	"./odiopay-logo.svg": 159,
	"./pdf.svg": 160,
	"./profit-report.svg": 161,
	"./settings-24px.svg": 162,
	"./settings-24pxx.svg": 79,
	"./sidebar-icons/customer.svg": 163,
	"./sidebar-icons/dashboard.svg": 164,
	"./sidebar-icons/loan.svg": 165,
	"./sidebar-icons/money.svg": 166,
	"./sidebar-icons/repayments.svg": 167,
	"./sidebar-icons/reports.svg": 80,
	"./sidebar-icons/savings.svg": 168,
	"./sidebar-icons/transactions.svg": 169,
	"./sidebar-icons/users.svg": 170,
	"./sidebar-icons2/Group 1233.svg": 171,
	"./sidebar-icons2/Group 2topbar.svg": 81,
	"./sidebar-icons2/Home 2new loanx3.svg": 82,
	"./sidebar-icons2/ICON - notificationstopbar.svg": 83,
	"./sidebar-icons2/Page-1new loanx3.svg": 84,
	"./sidebar-icons2/Path 34add.svg": 101,
	"./sidebar-icons2/XMLID_71_new loanx3.svg": 172,
	"./sidebar-icons2/accounting.svg": 173,
	"./sidebar-icons2/analysis-reportnew loanx3.svg": 85,
	"./sidebar-icons2/asset-management.svg": 174,
	"./sidebar-icons2/credit-card (8)new loanx3.svg": 86,
	"./sidebar-icons2/expense.svg": 175,
	"./sidebar-icons2/investor-transaction.svg": 176,
	"./sidebar-icons2/investor.svg": 177,
	"./sidebar-icons2/other-income.svg": 178,
	"./sidebar-icons2/payment-cardnew loanx3.svg": 87,
	"./sidebar-icons2/payroll.svg": 179,
	"./sidebar-icons2/savings-icon.svg": 180,
	"./sidebar-icons2/savings-transaction.svg": 181,
	"./sidebar-icons2/savingsnew loanx3.svg": 182,
	"./sidebar-icons2/user (8)new loanx3.svg": 88,
	"./sidebar-icons2/walletnew loanx3.svg": 89,
	"./university-solid.svg": 107,
	"./user.svg": 183,
	"./visibility-24px.svg": 100,
	"./wallet-solid.svg": 184,
	"./wallet.svg": 185,
	"./wallett.svg": 90
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 102;